import AnalyticsHelper from '../../utils/analytics-helper';

export default class Nav {
    constructor(parent) {
        this.parent = parent;
        this.router = parent.router;
        this.util = parent.util;
        this.el = parent.el.querySelector('.spa-navigation');
        this.links = [...this.el.querySelectorAll('a')];
        this.names = [...this.el.querySelectorAll('.user-name')];
        this.logout = this.el.querySelector('.user-info--logout');
        this.bind();
    }

    update() {
        const { path } = this.router;
        this.active(path);
    }

    bind() {
        this.util.addEventListener('login', () => {
            this.populate();
        });

        this.router.addEventListener(() => {
            this.update();
        });

        this.logout.addEventListener('click', (e) => {
            e.preventDefault();
            AnalyticsHelper.push(this.logout);
            this.util.logout();
        });
    }

    toggle(path, show) {
        const link = this.el.querySelector(`[href='${path}']`);
        show ? link?.parentElement?.classList.remove('hide') : link?.parentElement?.classList.add('hide');
    }

    active(path) {
        this.links.forEach((link) => link.parentElement.classList.remove('active'));
        const pathFragment = path.split('/')[0];
        const link = this.el.querySelector(`[href='${pathFragment}']`);
        link?.parentElement?.classList.add('active');
    }

    async populate() {
        const data = await this.util.client.getPersonalDetails();
        const firstName = data?.firstName;
        this.names.forEach((name) => name.textContent = firstName);
    }
}
